import { AiIcon, RecordPreview, Tag } from '@all-manager/design-system-v2';
import type { ExistingMatch } from '../../types/inbox.types';
import { useExistingMatchPreview } from './useExistingMatchPreview';

type Props = {
  match: ExistingMatch;
};

/** The record a suggestion may duplicate, so the user can compare before creating it. */
export default function ExistingMatchPreview(props: Props) {
  const hook = useExistingMatchPreview(props);

  return (
    <RecordPreview
      color={hook.preview.color}
      heading={hook.preview.heading}
      title={hook.preview.title}
      details={hook.preview.details}
      loading={hook.isLoading}
      tag={hook.preview.isCompleted ? <Tag color="done" variantIcon="state" label="Terminé" /> : undefined}
      note={hook.note}
      noteIcon={hook.isAiNote ? <AiIcon /> : undefined}
      action={
        hook.href && hook.preview.link
          ? { label: hook.preview.link.label, href: hook.href, openInNewTab: true }
          : undefined
      }
    />
  );
}
